<!--
 * @Description: 请输入当前文件描述
 * @Author: @Xin (834529118@qq.com)
 * @Date: 2020-09-05 15:07:34
 * @LastEditTime: 2020-11-06 11:12:14
 * @LastEditors:   YOYO [792611446@qq.com]
-->
<template>
  <div class="table-list">
    <div class="table-list-title" v-if='title'>{{title}}</div>

    <el-table
      style="width: 100%"
      v-bind="$attrs"
      v-on="$listeners">
      <slot></slot>
    </el-table>

    <div class="table-list-pages" v-if="pageCount">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-count="pageCount"
        v-bind="$attrs"
        v-on="$listeners"
        @current-change='pageChange'>
      </el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseTable',
  components: {},
  props: {
    title: {
      type: String,
      default: '',
    },
    pageCount: {
      type: Number,
      default: 0,
    },
  },
  data () {
    return {
    }
  },
  methods: {
    pageChange (e) {
      this.$emit('pageChange', e)
    },
  },
}
</script>

<style lang="less" scoped>
// @import '../assets/static/style/common';
.table-list {
  // border: 1px solid red;
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
  color: 14px;
  .table-list-title{
    font-size: 18px;
    color: #333;
    font-weight: bold;
    height: 70px;
    line-height: 70px;
  }
  .table-list-pages{
    // border: 1px solid red;
    margin-top: 35px;
    text-align: center;
    /deep/ .el-pager li{
      background-color: transparent;
      color: #333;
      width: 34px;
      height: 34px;
      line-height: 34px;
      &.number{
        border: 1px solid #666;
      }
    }
    /deep/ .el-pagination.is-background .btn-next, /deep/ .el-pagination.is-background .btn-prev{
      width: 34px;
      height: 34px;
    }
  }
  /deep/ .el-table .cell{
    height: 50px;
    line-height: 50px;
  }
  /deep/ .el-table td, /deep/ .el-table th{
    padding: 0;
    color: #333;
    font-size: 14px;
  }
  /deep/ .el-table th{
    background-color: #E9F0FA;
    color: #333;
  }
  /deep/ .el-table th>.cell{
    height: 56px;
    line-height: 56px;
  }
}
</style>
